import { api } from "./http-client";
import {
  CardOfInterest,
  CardInterestHistoryChartResponse,
  CardInterestListResponse,
  CardInterestListingsResponse,
  CardInterestListingPageOptionsDto,
  CardInterestPageOptionsDto,
  CardInterestRunNowResult,
  CreateCardInterestDto,
  EbayChannelConfig,
  FacebookChannelConfig,
  SnkrdunkChannelConfig,
  WhatsappChannelConfig,
  UpdateCardInterestDto,
} from "../types/card-interest";

export const cardInterestsService = {
  async list(
    params?: CardInterestPageOptionsDto,
  ): Promise<CardInterestListResponse> {
    const response = await api.request<CardInterestListResponse>({
      url: "/card-interests",
      method: "GET",
      params,
    });
    return response.data;
  },
  async create(data: CreateCardInterestDto): Promise<CardOfInterest> {
    const response = await api.request<CardOfInterest>({
      url: "/card-interests",
      method: "POST",
      data,
    });
    return response.data;
  },
  async getOne(id: string): Promise<CardOfInterest> {
    const response = await api.request<CardOfInterest>({
      url: `/card-interests/${id}`,
      method: "GET",
    });
    return response.data;
  },
  async listListings(
    id: string,
    params?: CardInterestListingPageOptionsDto,
  ): Promise<CardInterestListingsResponse> {
    const response = await api.request<CardInterestListingsResponse>({
      url: `/card-interests/${id}/listings`,
      method: "GET",
      params,
    });
    return response.data;
  },
  async getHistoryChart(
    id: string,
    days?: number,
  ): Promise<CardInterestHistoryChartResponse> {
    const response = await api.request<CardInterestHistoryChartResponse>({
      url: `/card-interests/${id}/history-chart`,
      method: "GET",
      params: typeof days === "number" ? { days } : undefined,
    });
    return response.data;
  },
  async update(id: string, data: UpdateCardInterestDto): Promise<CardOfInterest> {
    const response = await api.request<CardOfInterest>({
      url: `/card-interests/${id}`,
      method: "PATCH",
      data,
    });
    return response.data;
  },
  async remove(id: string): Promise<void> {
    await api.request({
      url: `/card-interests/${id}`,
      method: "DELETE",
    });
  },
  async runNow(id: string): Promise<CardInterestRunNowResult> {
    const response = await api.request<CardInterestRunNowResult>({
      url: `/card-interests/${id}/run`,
      method: "POST",
    });
    return response.data;
  },
  async uploadReferenceImage(id: string, file: File): Promise<CardOfInterest> {
    const form = new FormData();
    form.append("file", file);
    const response = await api.request<CardOfInterest>({
      url: `/card-interests/${id}/reference-image`,
      method: "POST",
      data: form,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },
  async getFacebookChannelConfig(): Promise<FacebookChannelConfig> {
    const response = await api.request<FacebookChannelConfig>({
      url: "/card-interests/facebook-channel",
      method: "GET",
    });
    return response.data;
  },
  async updateFacebookChannelConfig(
    data: Partial<FacebookChannelConfig> & {
      facebookCookie?: string;
      facebookUsername?: string;
      facebookPassword?: string;
    },
  ): Promise<FacebookChannelConfig> {
    const response = await api.request<FacebookChannelConfig>({
      url: "/card-interests/facebook-channel",
      method: "PATCH",
      data,
    });
    return response.data;
  },
  async getSnkrdunkChannelConfig(): Promise<SnkrdunkChannelConfig> {
    const response = await api.request<SnkrdunkChannelConfig>({
      url: "/card-interests/snkrdunk-channel",
      method: "GET",
    });
    return response.data;
  },
  async updateSnkrdunkChannelConfig(
    data: Partial<SnkrdunkChannelConfig>,
  ): Promise<SnkrdunkChannelConfig> {
    const response = await api.request<SnkrdunkChannelConfig>({
      url: "/card-interests/snkrdunk-channel",
      method: "PATCH",
      data,
    });
    return response.data;
  },
  async getEbayChannelConfig(): Promise<EbayChannelConfig> {
    const response = await api.request<EbayChannelConfig>({
      url: "/card-interests/ebay-channel",
      method: "GET",
    });
    return response.data;
  },
  async updateEbayChannelConfig(
    data: Partial<EbayChannelConfig>,
  ): Promise<EbayChannelConfig> {
    const response = await api.request<EbayChannelConfig>({
      url: "/card-interests/ebay-channel",
      method: "PATCH",
      data,
    });
    return response.data;
  },
  async getWhatsappChannelConfig(): Promise<WhatsappChannelConfig> {
    const response = await api.request<WhatsappChannelConfig>({
      url: "/card-interests/whatsapp-channel",
      method: "GET",
    });
    return response.data;
  },
  async updateWhatsappChannelConfig(
    data: Partial<WhatsappChannelConfig>,
  ): Promise<WhatsappChannelConfig> {
    const response = await api.request<WhatsappChannelConfig>({
      url: "/card-interests/whatsapp-channel",
      method: "PATCH",
      data,
    });
    return response.data;
  },
};
